import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LangDialogData {
  lang: { code: string, name: string, flag: string };
  isOpen: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LangConfirmService {
  private dialogSubject = new BehaviorSubject<LangDialogData | null>(null);

  constructor() { }

  observeDialog(): Observable<LangDialogData | null> {
    return this.dialogSubject;
  }

  openDialog(lang: { code: string, name: string, flag: string }) {
    this.dialogSubject.next({
      lang,
      isOpen: true
    });
  }

  closeDialog() {
    const current = this.dialogSubject.getValue();
    if (current) {
      this.dialogSubject.next({
        ...current,
        isOpen: false
      });
    }
  }
}